import { Component, ElementRef, Input, OnInit, Renderer2, ViewChild, ViewChildren,QueryList } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { HomeUiService } from '../home-ui.service';

@Component({
  selector: 'app-chapter-steps-modal',
  templateUrl: './chapter-steps-modal.component.html',
  styleUrls: ['./chapter-steps-modal.component.scss'],
})
export class ChapterStepsModalComponent implements OnInit {
  @Input() chapterStepsInfo;
  @ViewChildren("stepTitle") stepTitle:QueryList<ElementRef>;
  constructor(private modal: ModalController, private render:Renderer2, public homeUiService: HomeUiService) { }

  ngOnInit() {}
  closePopup() {
    this.modal.dismiss();
  }
  changeFont(index) {
       if(this.stepTitle) {
    const element = this.stepTitle.toArray()[index]?.nativeElement;
    // const element = step?.nativeElement;
    const specificElement = element?.querySelector('p') || element?.querySelector('h1') || element?.querySelector('h2') || element?.querySelector('h6');
    if(specificElement) {
      this.render.setStyle(specificElement, 'font-size', '20px');
      this.render.setStyle(specificElement, 'font-weight', '700');
      this.render.setStyle(specificElement, 'font-style', 'bold');
      this.render.setStyle(specificElement, 'line-height', '20px');
      this.render.setStyle(specificElement, 'font-family', 'Roboto');
     this.render.setStyle(specificElement, 'word-break', 'break-word');
     this.render.setStyle(specificElement, 'overflow', 'hidden');
     this.render.setStyle(specificElement, ' text-overflow', 'ellipsis');
     this.render.setStyle(specificElement, 'display', '-webkit-box');
     this.render.setStyle(specificElement, '-webkit-line-clamp', '2');
     this.render.setStyle(specificElement, '-webkit-box-orient', 'vertical');
     this.render.setStyle(specificElement, 'margin-bottom', '0');

    }
  return true;
    }
  }
}
